import { getKeyByValue } from '../helpers'
import { PILLARS_KEYS_BY_CAMEL_CASE_PILLARS, PILLARS_TEXT, RESOURCEdb } from './pillars'

export const DEFAULT_OPTION = { label: 'Select...', value: '' }

// Used: sortResources(U/Discover)
export const SORT_BY_OPTIONS = {
    featured: 'Featured',
    nameAsc: 'Name (A to Z)',
    nameDesc: 'Name (Z to A)',
    priceAsc: 'Price (low to high)',
    priceDesc: 'Price (high to low)',
    dateAsc: 'Date added (newest to oldest)',
    dateDesc: 'Date added (oldest to newest)',
}

// Used by Select(U/Discover).
export const SORT_BY_OPTIONS_ARRAY = Object.entries(SORT_BY_OPTIONS).map(([key, value]) => ({
    label: value,
    value: key,
}))

export const TIME_PERIODS = [
    { value: 'month', label: 'Month', data: 'monthly' },
    { value: 'quarter', label: 'Quarter', data: 'quarterly' },
    { value: 'year', label: 'Year', data: 'yearly' },
]

export const PILLARS_FILTER_OPTIONS = [
    { value: 'all', label: 'All pillars' },
    ...Object.values(RESOURCEdb.PILLARS).map(pillar => ({
        value: getKeyByValue(PILLARS_KEYS_BY_CAMEL_CASE_PILLARS, pillar),
        label: PILLARS_TEXT[pillar],
    })),
]

export const WELLBEING_IMPACT_DURATIONS = {
    wellbeingImpactOneMonth: 'oneMonth',
    wellbeingImpactThreeMonths: 'threeMonths',
    wellbeingImpactSixMonths: 'sixMonths',
}

export const DIRECTORY_OPTIONS_OBJECT = {
    topUsed: { label: 'Used', value: 'topUsed', text: 'used', graph: 'usedResources' },
    topSpent: { label: 'Spent', value: 'topSpent', text: 'spent', graph: 'spentResources' },
    topRated: { label: 'Rated', value: 'topRated', text: 'rated', graph: 'ratedResources' },
    // sharedResources: { label: 'Shared', value: 'sharedResources', text: 'shared' },
    // viewsFromGoals: {
    //     label: 'Views from goals',
    //     value: 'viewsFromGoals',
    //     text: 'by views from goals',
    // },
    // viewsFromDirectory: {
    //     label: 'Views from directory',
    //     value: 'viewsFromDirectory',
    //     text: 'by views from directory',
    // },
    // [Object.keys(WELLBEING_IMPACT_DURATIONS)[0]]: {
    //     label: 'Wellbeing impact after 1 month',
    //     value: Object.keys(WELLBEING_IMPACT_DURATIONS)[0],
    //     text: 'by wellbeing impact after 1 month',
    // },
    // [Object.keys(WELLBEING_IMPACT_DURATIONS)[1]]: {
    //     label: 'Wellbeing impact after 3 months',
    //     value: Object.keys(WELLBEING_IMPACT_DURATIONS)[1],
    //     text: 'by wellbeing impact after 3 months',
    // },
    // [Object.keys(WELLBEING_IMPACT_DURATIONS)[2]]: {
    //     label: 'Wellbeing impact after 6 months',
    //     value: Object.keys(WELLBEING_IMPACT_DURATIONS)[2],
    //     text: 'by wellbeing impact after 6 months',
    // },
}

export const DIRECTORY_OPTIONS = Object.values(DIRECTORY_OPTIONS_OBJECT)
